var lib_core = require("lib-core")

var TechnologyData = function () {
    this.makeObservableTreeNode();
    var self = this;

    this.properties = this.map("properties", true);
};

lib_core.mixin(TechnologyData, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(TechnologyData, "TechnologyData");

module.exports = TechnologyData;
